import { useContext, useState } from "react"
import { AuthFetchTGUIO } from "../../services/api";
import { notify } from "../../utils/utils";
import { useModal } from "../useModal";

export const useGroups = () => {
    const grupoDefault = {
        CodGrupo: 0,
        NomGrupo: '',
        Descripcion:'',
        UrlFotoPerfil: '',
        CantidadParticipantes: '',
        NomRuta: '',
        IdRoom: 0
    };
    const [ grupos, setGrupos ] = useState([]);
    const [ grupo, setGrupo ] = useState(grupoDefault);
    const [ gruposUID, setGruposUID ] = useState([])
    const [ isOpenModalRegistrar, openModalRegistrar, closeModalRegistrar ] = useModal(null);
    const [ rutas, setRutas ] = useState([]);
    const [ gruposEmpresaUid, setGruposEmpresaUid ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    

    const listarGruposPorEmpresa = async (codEmpresa) => {
        try
        {
            setLoading(true);
            const response = await AuthFetchTGUIO(`/chat-groups/${codEmpresa}/company`)
            setGrupos(response.isValid ? response.content : []);
            !response.isValid && notify(response.exceptions[0].description, 'error');
        }
        catch(error)
        {
            setGrupos([])
            notify('Ocurrió un error en el servicio','error');
            console.log('error al listar ',error);
        }
        setLoading(false);
    }

    const listarGruposPorUID = async () => {
        try
        {
            const response = await AuthFetchTGUIO('/chat-groups/uid');
            !response.isValid && notify(response.exceptions[0].description,'error');
            setGruposUID(response.isValid ? response.content : [])
        }
        catch(error){
            setGruposUID([]);
            notify('Ocurrió un error en el servicio','error');
            console.log('error al listar por uid ',error);
        }
    }

    const obtenerDatosGrupo = async (currentRoom) => {
        editarValorGrupo("IdRoom",currentRoom.id);
        editarValorGrupo("NomGrupo",currentRoom.nameRoom);
        editarValorGrupo("Descripcion",currentRoom.descriptionRoom);
        editarValorGrupo("NomRuta",currentRoom.nameRoute);
        editarValorGrupo("URLFotoPerfil",currentRoom.urlImageRoom);
    }

    const obtenerDatosGrupoModulo = async (data) => {
        if(data)
        {
            editarValorGrupo("IdRoom",data.IdRoom);
            editarValorGrupo("NomGrupo",data.NomGrupo);
            editarValorGrupo("CodGrupo",data.CodGrupo);
            editarValorGrupo("Descripcion",data.Descripcion);
            editarValorGrupo("NomRuta",data.NomRuta);
            editarValorGrupo("URLFotoPerfil",data.UrlFotoPerfil);
        }
        else
        {
            setGrupo(grupoDefault)
        }
    }

    const guardarEditarGrupo = async (urlImagen) => {
        try
        {
            const esGuardar = grupo.IdRoom === 0 ? true : false;  
            const response = await AuthFetchTGUIO('/chat-groups',{
                method: esGuardar ? 'POST' : 'PUT' ,
                body: JSON.stringify({
                    ...(
                        !esGuardar ?
                            {
                                IdRoom: grupo.IdRoom,
                            }
                        :
                            {
                                CodEmpresa: grupo.CodEmpresa,
                                CodRuta: grupo.CodRuta,
                            }
                            
                    ),
                    NomRuta: grupo.NomRuta,
                    NomGrupo: grupo.NomGrupo,
                    Descripcion: grupo.Descripcion,
                    URLFotoPerfil: urlImagen
                }),
            });
            notify((response.isValid ? response.content : response.exceptions[0].description), (response.isValid ? 'success' : 'error'));
            return response.isValid
        }
        catch(error)
        {
            notify('Ocurrió un error en el servicio', 'error');
            console.log('error al guardar ',error);
        }
        return false;
    }

    const editarValorGrupo = (key, value) => {
        setGrupo(usuario => {
            return {
                ...usuario,
                [key]: value
            }
        });
    }

    const listarRutasPorEmpresa = async (codEmrpesa) => {
        try
        {
            const response = await AuthFetchTGUIO(`/routes/${codEmrpesa}/company`);
            if(response.isValid){
                setRutas(response.content)
            }
            else{
                setRutas([]);
            }
        }
        catch(error)
        {
            setRutas([]);
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar rutas ',error)
        }
    }

    const listarGruposPorEmpresaUID = async (uid,codEmpresa) => {
        try{

            const response = await AuthFetchTGUIO(`/chat-groups/${codEmpresa}/belong/${uid}`)
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setGruposEmpresaUid(response.isValid ? response.content : [])
            

        }
        catch(error){
            setGruposEmpresaUid([]);
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar',error)
        }
    }

    return{
        grupo,
        grupos,
        gruposUID,
        rutas,
        listarGruposPorEmpresa,
        listarGruposPorUID,
        obtenerDatosGrupo,
        guardarEditarGrupo,
        obtenerDatosGrupoModulo,
        editarValorGrupo,
        listarRutasPorEmpresa,
        openModalRegistrar,
        isOpenModalRegistrar,
        closeModalRegistrar,
        listarGruposPorEmpresaUID,
        gruposEmpresaUid,
        setGruposEmpresaUid,
        loading
    }
}